import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useFlagStore } from '@/stores/flag';

export async function constellationProAccessGuard(): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();

  await flagStore.waitForUserFlags;
  if (flagStore.ready && flagStore.flags.constellationPro) {
    return true;
  }

  return { path: '/not-found' };
}

// Brand Governance replaces the Brand Guidelines page for flagged brands; everyone else
// keeps Brand Guidelines, so send an unflagged brand there rather than to a 404. Governance
// also redirects this way when a brand switch drops the flag while the page is open.
export async function brandGovernanceAccessGuard(
  to: RouteLocationNormalized,
): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();

  await flagStore.waitForUserFlags;
  if (flagStore.ready && flagStore.flags.cpBgSettings) {
    return true;
  }

  return {
    name: 'constellation-pro.brand-guidelines',
    params: { brandLabel: to.params.brandLabel },
  };
}
